export default {
  heading: 'Charm, cursive',
  body: 'Playfair Display, serif',
  monospace: 'Menlo, monospace',
  display: 'Playfair Display, serif',
  googleFonts: ['Playfair Display:100,200,300,400,500,600,700,800,900', 'Charm:400,700']
  // customFamilies: [''],
  // customUrls: [''],
}
